import {
    OrganizationTaskTemplateSortBy,
    OrganizationTaskTemplateSortDirection,
} from "@common/schemas/organization-task-template.schema";

export type OrganizationTaskTemplateSortValue =
    `${OrganizationTaskTemplateSortBy}_${OrganizationTaskTemplateSortDirection}`;

export const columnSort = (sortBy: OrganizationTaskTemplateSortBy) => ({
    asc: `${sortBy}_${OrganizationTaskTemplateSortDirection.ASC}` as const,
    desc: `${sortBy}_${OrganizationTaskTemplateSortDirection.DESC}` as const,
});

export const parseTemplateSort = (
    sort: OrganizationTaskTemplateSortValue | undefined,
): {
    sortBy?: OrganizationTaskTemplateSortBy;
    sortDirection?: OrganizationTaskTemplateSortDirection;
} => {
    if (!sort) {
        return {};
    }
    const separatorIndex = sort.lastIndexOf("_");
    const rawSortBy = sort.slice(0, separatorIndex);
    const rawDirection = sort.slice(separatorIndex + 1);
    return {
        sortBy: Object.values(OrganizationTaskTemplateSortBy).find(
            (value) => value === rawSortBy,
        ),
        sortDirection: Object.values(
            OrganizationTaskTemplateSortDirection,
        ).find((value) => value === rawDirection),
    };
};

const DEFAULT_TEMPLATE_SORT_BY = OrganizationTaskTemplateSortBy.CREATED_AT;

export const DEFAULT_TEMPLATE_SORT: OrganizationTaskTemplateSortValue =
    columnSort(DEFAULT_TEMPLATE_SORT_BY).desc;

export const isDefaultTemplateSortColumn = (
    sort: OrganizationTaskTemplateSortValue,
): boolean => parseTemplateSort(sort).sortBy === DEFAULT_TEMPLATE_SORT_BY;
